import { Navigate } from 'react-router-dom';
import { useAuthStore } from '@/stores/authStore';
import { ROLE_HOME_PATH } from '@/lib/constants';

/** "/" — login qilingan bo'lsa rol bo'yicha, aks holda /login ga */
export function RootRedirect() {
  const user = useAuthStore((s) => s.user);
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);

  if (isAuthenticated && user) {
    return <Navigate to={ROLE_HOME_PATH[user.role]} replace />;
  }
  return <Navigate to="/login" replace />;
}
